(() => {
  angular
    .module('app.components')
    .factory('deviceTypeRatioConfig', deviceTypeRatioConfig);

  // deviceTypeRatioConfig.$inject = [];

  function deviceTypeRatioConfig() {
    const DEVICES = {
      Desktop: {
        color: '#17D6D8',
        linux: {
          name: 'Linux',
          color: '#F7BE31',
        },
        windows: {
          name: 'Windows',
          color: '#1EB6EF',
        },
        macosx: {
          name: 'Apple OSX',
          color: '#3D3D3D',
        },
        chromeos: {
          name: 'Chrome OS',
          color: '#F44336',
        },
        other: {
          name: 'Other',
          color: '#96A6A6',
        },
      },
      Tablet: {
        color: '#117E7F',
        iPad: {
          name: 'iPad',
          color: '#3D3D3D',
        },
        android: {
          name: 'Android',
          color: '#BAD951',
        },
        windows: {
          name: 'Windows',
          color: '#1EB6EF',
        },
        other: {
          name: 'Other',
          color: '#96A6A6',
        },
      },
      Mobile: {
        color: '#9EE00F',
        iphone: {
          name: 'iPhone',
          color: '#3D3D3D',
        },
        android: {
          name: 'Android',
          color: '#BAD951',
        },
        windowsPhone: {
          name: 'Windows Phone',
          color: '#1EB6EF',
        },
        other: {
          name: 'Other',
          color: '#96A6A6',
        },
      },
      TV: {
        color: '#A997EB',
        roku: {
          name: 'Roku',
          color: '#9F69D0',
        },
        webTV: {
          name: 'WebTV',
          color: '#2196F3',
        },
        hbbTV: {
          name: 'HbbTV',
          color: '#999999',
        },
        YouView: {
          name: 'YouView',
          color: '#1CA8FC',
        },
        smartTV: {
          name: 'SmartTV',
          color: '#D968EA',
        },
        appleTV: {
          name: 'Apple TV',
          color: '#3D3D3D',
        },
        console: {
          name: 'Consoles',
          color: '#42E286',
        },
        chromecast: {
          name: 'Chromecast',
          color: '#ADADAD',
        },
        AmazonFireTV: {
          name: 'Amazon Fire TV',
          color: '#F94D1F',
        },
        SmartHub: {
          name: 'Samsung Smarthub',
          color: '#86D4EE',
        },
        other: {
          name: 'Other',
          color: '#96A6A6',
        },
      },
      Other: {
        color: '#96A6A6',
      },
    };

    const OPTIONS = {
      chart: {
        type: 'pie',
        height: 400,
        spacingTop: 0,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function () {
              return `
                <div class="dtr-pie-datalabel">
                  <i class="dtr-pie-datalabel__icon" data-icon="${this.point.name}"></i>
                  <b class="dtr-pie-datalabel__value">${this.point.name}</b>:
                  <span class="dtr-pie-datalabel__percent">
                    ${this.point.percentage < 1 ? '<1' : Highcharts.numberFormat(this.point.percentage, 0, ',', '.')}%
                  </span>
                  <i class="dtr-pie-datalabel__expand ${this.point.expand}"></i>
                </div>`;
            },
          },
          size: 250,
          innerSize: 170
        }
      },
      tooltip: {
        useHTML: true,
        shadow: false,
        hideDelay: 50,
        borderWidth: 0,
        borderRadius: 0,
        percentageDecimals: 2,
        formatter: function () {
          return `
            <div class="dtr-tooltip"><div class="dtr-tooltip__row dtr-tooltip__row_header">
              ${this.point.name}
            </div>
            <div class="dtr-tooltip__row">
              <span class="dtr-tooltip__row_bullet" style="background-color:${this.point.color};"></span>
              <b>
                ${this.point.percentage < 1 ? '<1' : Highcharts.numberFormat(this.point.percentage, 0, ',', '.')}%
              </b>
              of total ${this.series.name} traffic
            </div>
            <div class="dtr-tooltip__row">
              <span class="dtr-tooltip__row_bullet" style="background-color:${this.point.color};"></span>
              <b>${Highcharts.numberFormat(this.point.y, 0, ',', '.')}</b>
              impressions
            </div>`;
        }
      },
    };

    return {
      DEVICES,
      OPTIONS,
    }
  }
})();
